import * as api from "services/api";
import { getErrors } from "helpers/error";

export const UPDATE_COMPANY = "[COMPANY UPDATE] UPDATE_COMPANY";
export const UPDATE_COMPANY_ERROR = "[COMPANY UPDATE] UPDATE_COMPANY_ERROR";
export const UPDATE_COMPANY_SUCCESS = "[COMPANY UPDATE] UPDATE_COMPANY_SUCCESS";

export const UPLOAD_BUSINESS_LICENSE_FILE =
	"[UPDATE_COMPANY] UPLOAD_BUSINESS_LICENSE_FILE";
export const UPLOAD_BUSINESS_LICENSE_FILE_ERROR =
	"[UPDATE_COMPANY] UPLOAD_BUSINESS_LICENSE_FILE_ERROR";
export const UPLOAD_BUSINESS_LICENSE_FILE_SUCCESS =
	"[UPDATE_COMPANY] UPLOAD_BUSINESS_LICENSE_FILE_SUCCESS";

export const SET_VALUE = "[COMPANY UPDATE] SET_VALUE";
export const CLEAR_VALUES = "[COMPANY UPDATE] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function updateCompany(id, model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: UPDATE_COMPANY
		});

		try {
			const { login } = getState();

			let response = await api.sendPut(`/company/${id} `, model, {
				Authorization: "Bearer " + login.token
			});

			if (response.ok) {
				dispatch({
					type: UPDATE_COMPANY_SUCCESS
				});

				callback && callback();
			} else {
				let result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: UPDATE_COMPANY_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: UPDATE_COMPANY_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function uploadBusinessLicenseFile(id, file, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: UPLOAD_BUSINESS_LICENSE_FILE
		});

		try {
			const { login } = getState();

			if (!id) {
				id = login.user.id;
			}

			let response = await api.sendPostFile(
				`/company/license/${id}/file`,
				file,
				{
					Authorization: "Bearer " + login.token
				}
			);

			if (response.ok) {
				dispatch({
					type: UPLOAD_BUSINESS_LICENSE_FILE_SUCCESS
				});

				callback && callback();
			} else {
				let result = await response.json();
				dispatch({
					type: UPLOAD_BUSINESS_LICENSE_FILE_ERROR,
					payload: getErrors(result.errors)
				});
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: UPLOAD_BUSINESS_LICENSE_FILE_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
